import React from 'react';
import { getIntl } from '../../../utils/intl';
import {
    CareTeamMemberSource,
    OrgOrProfileCareTeamMember,
    getCareTeamMemberAvatarUrl,
    getCareTeamMemberDescriptor,
} from '../../../utils/careTeamUtils';
import { LoadableAvatar, getFallbackForGenericString, getFallbackFromName } from '../../v2BaseComponents/Avatar';
import Stack from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import Chip from '../../v2BaseComponents/Chip';

const intl = getIntl('CareTeamMemberHeader', {
    support: 'Support',
    insurance: 'Insurance',
    provider: 'Provider',
});

export type CareTeamMemberHeaderOwnProps = {
    source: CareTeamMemberSource;
    careTeamMemberId: string;
    careTeamMember: OrgOrProfileCareTeamMember;
    minimal?: boolean;
};

export type CareTeamMemberHeaderProps = CareTeamMemberHeaderOwnProps;

const CareTeamMemberHeader: React.FC<CareTeamMemberHeaderProps> = ({
    source,
    careTeamMemberId,
    careTeamMember,
    minimal,
}) => {
    const careTeamMemberDescriptor = getCareTeamMemberDescriptor(careTeamMember);
    const fallbackName =
        careTeamMemberDescriptor.type === 'name'
            ? getFallbackFromName(careTeamMemberDescriptor.firstName, careTeamMemberDescriptor.lastName)
            : getFallbackForGenericString(careTeamMemberDescriptor.text);
    const minimalDescriptor =
        careTeamMemberDescriptor.type === 'name'
            ? careTeamMemberDescriptor.firstName + ' ' + careTeamMemberDescriptor.lastName
            : careTeamMemberDescriptor.text;

    const getDescriptionText = () => {
        if (minimal) return minimalDescriptor;
        return careTeamMemberDescriptor.type === 'name'
            ? `${careTeamMemberDescriptor.firstName} ${careTeamMemberDescriptor.lastName}`
            : careTeamMemberDescriptor.text;
    };
    return (
        <Stack horizontal space={2.5}>
            <LoadableAvatar
                size="md"
                avatarUrl={getCareTeamMemberAvatarUrl(source, careTeamMemberId)}
                fallbackName={fallbackName}
            />
            <Stack vertical space={1} justify="center" align="flex-start">
                <Text variant="h4">{getDescriptionText()}</Text>
                <Chip title={intl(careTeamMember.careTeamMemberType)} />
            </Stack>
        </Stack>
    );
};

export default React.memo(CareTeamMemberHeader);
